import { PortableTextBlock, stegaClean } from 'next-sanity'

import PortableTextMinimal from '@/app/components/PortableTextMinimal'
import { TRACKING_LOCATIONS } from '@/app/utils/analytics'
import { cn } from '@/app/utils/style'
import { GetPageQueryResult, HomeQueryResult } from '@/sanity.types'

type PageHeadingProps = {
  page: GetPageQueryResult | HomeQueryResult
}

export function PageHeading({ page }: PageHeadingProps) {
  if (!page || page._type === 'home') {
    return null
  }

  const { heading, overline } = page
  const headingSection = stegaClean(page.headingSection)

  if (headingSection === 'none' || !headingSection || !heading) {
    return null
  }

  const alignmentClass = headingSection === 'center' ? 'text-center' : 'text-left'

  return (
    <div className="content-container mt-5xl lg:mt-9xl">
      <div className="max-w-[1010px] mx-auto">
        <div className={cn('flex flex-col gap-sm', alignmentClass)}>
          {overline && (
            <p className="font-black uppercase size-overline-sm lg:size-overline-md">{overline}</p>
          )}
          <h1 className="size-heading-md lg:size-heading-xl">
            <PortableTextMinimal
              value={heading as PortableTextBlock[]}
              tracking={{ location: TRACKING_LOCATIONS.PAGE_CONTENT }}
            />
          </h1>
          <hr className="my-3xl lg:my-5xl" />
        </div>
      </div>
    </div>
  )
}
